<template>
    <div class="bg-white w-full flex flex-col items-center justify-center align-center">
      <div class="w-full mx-auto text-center justify-center  align-center mt-64 ">
       
        <svg width="170" height="169" viewBox="0 0 170 169" fill="none" xmlns="http://www.w3.org/2000/svg" class="mx-auto">
            <rect x="0.5" width="169" height="169" rx="84.5" fill="#DEDEDE" />
            <mask id="mask0_639_649" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="37" y="36" width="96" height="97">
                <rect x="37" y="36.5" width="96" height="96" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_639_649)">
                <path
                    d="M86.6 114.3L55.2 82.9C53.6667 81.3667 52.9 79.5667 52.9 77.5C52.9 75.4333 53.6667 73.6333 55.2 72.1L72.6 54.7C74.1333 53.1667 75.9333 52.4 78 52.4C80.0667 52.4 81.8667 53.1667 83.4 54.7L114.8 86.1C116.333 87.6333 117.1 89.4333 117.1 91.5C117.1 93.5667 116.333 95.3667 114.8 96.9L97.4 114.3C95.8667 115.833 94.0667 116.6 92 116.6C89.9333 116.6 88.1333 115.833 86.6 114.3ZM92 108.5L109 91.5L78 60.5L61 77.5L92 108.5ZM85 132.5C78.4 132.5 72.1833 131.25 66.35 128.75C60.5167 126.25 55.4167 122.817 51.05 118.45C46.6833 114.083 43.25 108.983 40.75 103.15C38.25 97.3167 37 91.1 37 84.5H45C45 89.2333 45.8 93.7667 47.4 98.1C49 102.433 51.2167 106.333 54.05 109.8C56.8833 113.267 60.2667 116.217 64.2 118.65C68.1333 121.083 72.4333 122.8 77.1 123.8L66.6 113.3L72.2 107.7L95.8 131.3C94.0667 131.7 92.2833 132 90.45 132.2C88.6167 132.4 86.8 132.5 85 132.5ZM125 84.5C125 79.7667 124.2 75.2333 122.6 70.9C121 66.5667 118.783 62.6667 115.95 59.2C113.117 55.7333 109.733 52.7833 105.8 50.35C101.867 47.9167 97.5667 46.2 92.9 45.2L103.4 55.7L97.8 61.3L74.2 37.7C75.9333 37.3 77.7167 37 79.55 36.8C81.3833 36.6 83.2 36.5 85 36.5C91.6 36.5 97.8167 37.75 103.65 40.25C109.483 42.75 114.583 46.1833 118.95 50.55C123.317 54.9167 126.75 60.0167 129.25 65.85C131.75 71.6833 133 77.9 133 84.5H125Z"
                    fill="#575757" />
            </g>
        </svg>
       
      </div>
      <div class="mx-auto mt-2 w-10/12 text-center">
        <span class="text-3xl">
          {{ $t("message.LicensesManager.rotateScreen.title") }}
        </span>
      </div>
      <div class="mx-auto mt-2 w-9/12 text-center">
        <span class="font-normal text-xl text-gray-800">
          {{ $t("message.LicensesManager.rotateScreen.subtitle") }}
        </span>
      </div>
      <div class="mx-auto font-normal mt-2 w-9/12 text-center">
        <span class="text-gray-700  ">
          {{ $t("message.LicensesManager.rotateScreen.hint") }}
        </span>
      </div>
    </div>
  </template>
  
  <script>
  
  
  export default {
  }
  </script>